import { mmWidgetInit, tpgWidgetInit, smsbWidgetInit } from "../zendeskWidget";

export type Brand = "mm" | "tpg" | "smsb";
type Config = {
  [B in Brand]: {
    brand: B;
    zendeskKey: string;
    initZendeskWidget: () => void;
  };
};

const config: Config = {
  mm: {
    brand: "mm",
    zendeskKey: "a59b7ab5-9dea-4a60-bbbb-8c1d7d400a2a",
    initZendeskWidget: mmWidgetInit,
  },
  smsb: {
    brand: "smsb",
    zendeskKey: "b3d0b58b-cc88-4540-b718-b5ab4fdd3631",
    initZendeskWidget: smsbWidgetInit,
  },
  tpg: {
    brand: "tpg",
    zendeskKey: "bc043523-b8ba-429a-af95-2fbfb0e88b64",
    initZendeskWidget: tpgWidgetInit,
  },
};

export const getVendorConfig = (vendor: Brand) => config[vendor];
